export default "__VITE_ASSET__h9Ye6oUS__"